const purchaseHistorySelector = store => store.purchasedHistory;

export default purchaseHistorySelector;
